import script from "./textInput.vue?vue&type=script&setup=true&lang=js"
export * from "./textInput.vue?vue&type=script&setup=true&lang=js"

import "./textInput.vue?vue&type=style&index=0&id=dbab6a2a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbab6a2a"]])

export default __exports__